import React from 'react';
import { ICampaign } from '../interfaces';
import { computeCampaignPercentage, computeCampaignsPercentage, getWeekNumber } from '../utils';

interface IProps {
    onWeekSelect: (weekNumber: number) => void;
    date: Date;
    campaigns: ICampaign[];
    maxDevices: number;
}

interface IElementProps {
    campaigns: ICampaign[];
    day: number;
    maxDevices: number;
}

const CalendarDayCampaignElement = (props: IElementProps) => {
    return (
        <div className="calendarElement">
            <p>Campagnes: {props.campaigns.length}</p>
            <p>Espace Utilisé: {computeCampaignsPercentage(props.campaigns, props.day, props.maxDevices)}%</p>
            {props.campaigns.length === 0 || (
                <div className="popup">
                    {props.campaigns.map((c) => (
                        <p key={c.id}>
                            <strong>{c.name}</strong>: {c.planning[props.day].length}h, {c.slots} slots,{' '}
                            {c.devices.length} ecrans (
                            {Math.round(10000 * computeCampaignPercentage(c, props.day, props.maxDevices)) / 100}%)
                        </p>
                    ))}
                </div>
            )}
        </div>
    );
};

const Calendar = (props: IProps) => {
    const start = new Date(props.date);
    const today = new Date();
    start.setDate(1);

    if (start.getDay() > 1) {
        start.setDate(start.getDate() - start.getDay() + 1);
    } else if (start.getDay() === 0) {
        start.setDate(start.getDate() - 6);
    }

    const weeks = [];

    while (start.getTime() < props.date.getTime() || start.getMonth() === props.date.getMonth()) {
        const weekNumber = getWeekNumber(start);

        const days = [
            <td key="special" className="special">
                <p>{weekNumber}</p>
            </td>
        ];

        for (let i = 0; i < 7; i++) {
            const campaignsOfDay = props.campaigns.filter(({ startDate, endDate, planning }) => {
                const startOfDay = new Date(start);
                const endOfDay = new Date(start);
                endOfDay.setHours(23, 59, 59, 999);

                return startDate <= startOfDay && endDate >= endOfDay && planning[i].length > 0;
            });

            let classes = 'day';
            let tdClasses = '';

            if (start.getMonth() !== props.date.getMonth()) {
                classes += ' outside';
            }

            if (start.getDay() === 0 || start.getDay() === 6) {
                tdClasses += 'we';
            }

            if (start.getDate() === today.getDate() && start.getMonth() === today.getMonth() && start.getFullYear() === today.getFullYear()) {
                tdClasses += ' today';
            }

            if (campaignsOfDay.length >= 5) {
                tdClasses += ' full';
            }

            days.push(
                <td className={tdClasses} key={i}>
                    <div className={classes}>{start.getDate()}</div>
                    <CalendarDayCampaignElement campaigns={campaignsOfDay} day={i} maxDevices={props.maxDevices} />
                </td>
            );
            start.setDate(start.getDate() + 1);
        }

        weeks.push(
            <tr onClick={() => props.onWeekSelect(weekNumber)} key={start.getDate() - 7}>
                {days}
            </tr>
        );
    }

    return (
        <table className="calendar">
            <thead>
                <tr>
                    <th className="week">sem.</th>
                    <th>lun.</th>
                    <th>mar.</th>
                    <th>mer.</th>
                    <th>jeu.</th>
                    <th>ven.</th>
                    <th style={{ color: '#8D8D8D' }}>sam.</th>
                    <th style={{ color: '#8D8D8D' }}>dim.</th>
                </tr>
            </thead>
            <tbody>{weeks}</tbody>
        </table>
    );
};

export default Calendar;
